import { NextPage } from 'next';
import { CompanyJsonLd } from '~/common/components/CompanyJsonLd';
import { SEO } from '~/common/components/SEO';

import { LoginPage } from '~/modules/login/pages';

const Index: NextPage = () => {
  return (
    <>
      <SEO />
      <CompanyJsonLd />

      <LoginPage />
    </>
  );
};

export default Index;
